import { render, staticRenderFns } from "./AppSidebarMenu.vue?vue&type=template&id=0539b958&scoped=true&"
import script from "./AppSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./AppSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebarMenu.vue?vue&type=style&index=0&id=0539b958&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539b958",
  null
  
)

export default component.exports